module.exports = __webpack_public_path__ + "static/media/RLC_9201a.c6a12afe.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/fluvial/RLC_9201a.JPG
// module id = 110
// module chunks = 0